import React from 'react';
import type { IconProps } from '../types';

export const ViewportViews = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <linearGradient
        id="viewportHorizontal"
        x1="4"
        y1="27"
        x2="60"
        y2="27"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#5558FF" />
        <stop offset="1" stopColor="#00C0FF" />
      </linearGradient>

      <linearGradient
        id="viewportCenter"
        x1="21"
        y1="26.94"
        x2="39.13"
        y2="26.94"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#2AF598" />
        <stop offset="1" stopColor="#009EFD" />
      </linearGradient>
    </defs>

    {/* Horizontal view */}
    <rect
      x="4"
      y="18"
      width="56"
      height="18"
      rx="2"
      fill="url(#viewportHorizontal)"
    />

    {/* Vertical view */}
    <rect
      x="21"
      y="4"
      width="18"
      height="56"
      rx="2"
      fill="#00FFE1"
    />

    {/* Center overlap */}
    <rect
      x="21"
      y="18.07"
      width="18.12"
      height="17.75"
      rx="2"
      fill="url(#viewportCenter)"
      opacity="0.83"
    />
  </svg>
);

export default ViewportViews;